import React from "react";
import { NavDropdown } from "react-bootstrap";
import "./../topBar/topBar.css";
import packageJson from  "../../../package.json"


export default class UserMenu extends React.Component {
  handlerLogout = () => {
    localStorage.removeItem("@oee-monitor/token");
    localStorage.removeItem("@oee-monitor/user"); 
    localStorage.removeItem("@oee-monitor/expiry");
    localStorage.removeItem("@oee-monitor/id");
  };

  render() {
    const username = localStorage.getItem("@oee-monitor/user");
    const admin = localStorage.getItem("@oee-monitor/admin");
    return (
      <>
        <NavDropdown alignRight title={username}>
          <NavDropdown.Item className={'username'} href="#/preferencias">
            Preferências
          </NavDropdown.Item>
          {
            /*window.screen.width > 1280 ?  
            <NavDropdown.Item className={'username'} 
            href="#/dashboardTV">Modo TV
             </NavDropdown.Item>:null*/
          }
          
          <NavDropdown.Item className={'username'} href={`#/${packageJson.client}`} onClick={this.handlerLogout}>
            Sair
          </NavDropdown.Item>
        </NavDropdown>
      </>
    );
  }
}